import { twMerge } from 'tailwind-merge';

import { Icon } from '@/_components';

import { addressUspsValidatedLucideIcon } from './address-usps-validated-lucide';

const iconClassName = 'text-accent size-5 shrink-0 dark:text-primary';

export type AddressUspsValidatedIconProps = {
  className?: string;
};

/**
 * USPS-validated address indicator (shield with check). Prefer this over ad-hoc `ShieldCheck` usage
 * so styling stays aligned with address sections and lists.
 */
export function AddressUspsValidatedIcon({ className }: AddressUspsValidatedIconProps) {
  return <Icon icon={addressUspsValidatedLucideIcon} className={twMerge(iconClassName, className)} />;
}
